
<template>
  <div class="bulb-section">
    <q-img class="image" src="images\bulb_title.jpg"></q-img>
    <div class="description">
      <div>
        <div class="section-title">Simple BULB recordings</div>
        <div class="section-paragraph">
          Gone are the days when you had to look at a stopwatch during exposure. Camoodoo always shows you the current exposure time.
          With the integrated Bulb-Timer you can also easily select a time of up to 15 minutes.
          The recording is then automatically stopped at the right time.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.bulb-section {
  display: grid;
  grid-template-columns: 2fr 3fr;
  align-items: center;
  justify-items: center;
  grid-gap: var(--content-margin);
}
.description {
  padding: var(--section-padding);
}
.image {
  align-self: stretch;
  justify-self: stretch;
  background-position-x: center;
  background-position-y: bottom;
  background-size: cover;
}
</style>
